import { defineStore } from "pinia";
import Services from '@/services/sutting/levelOneServices'
import { mapList, mapLevelOne } from '@/helpers/mapFuncs'

export const useLevelOneStore = defineStore("levelOne", {
persist: true,
state:()=>({
    levelOne: {},
    levelOnes: [],
}),
getters : {
    getLevelOne() {
        return mapLevelOne(this.levelOne)
    },
    getLevelOnes() {
        return this.levelOnes.map(mapLevelOne)
    },
    getLevelOnesList() {
        return this.levelOnes.map(mapList)
    }
},
actions : {
    /** Start Sets */
    setLevelOne(levelOne) {
        this.levelOne = levelOne
    },
    setLevelOnes(levelOnes) {
        this.levelOnes = levelOnes
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setLevelOne(response.data.data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setLevelOnes(response.data.data??[])
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.levelOnes.push(response.data.data)
            return response
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            this.levelOnes[this.levelOnes.findIndex((x)=>x.id == id)] = response.data.data
            return response
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.levelOnes = this.levelOnes.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});
